import { IConfigManager } from '@cp/shared/config';
import { IRouter, NavigateParams } from '@cp/shared/router';
import { History } from 'history';

export class BrowserRouter implements IRouter {
  #appOrigin: string;
  #history: History;
  constructor(config: IConfigManager, history: History) {
    this.#appOrigin = config.get('CLIENT_WEB_ORIGIN', '') as string;
    this.#history = history;
  }

  get location() {
    return window.location;
  }

  navigate(uri: string | URL, options?: NavigateParams) {
    return new Promise<void>((resolve, reject) => {
      if (!uri) {
        return reject(new Error('Unexpected empty URI'));
      }
      const targetUrl = new URL(uri, this.#appOrigin);
      if (window.location.origin === targetUrl.origin) {
        const method = options?.method === 'replace' ? this.#history.replace : this.#history.push;
        method({ pathname: targetUrl.pathname, search: targetUrl.search, hash: targetUrl.hash });
      } else if (targetUrl.protocol.startsWith('http')) {
        if (options?.method === 'replace') {
          window.location.href = targetUrl.toString();
        } else {
          window.open(targetUrl, '_blank'); // open external urls in new tab
        }
      } else {
        window.location.href = targetUrl.toString();
      }
      resolve();
    });
  }
}
